import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function ClockIcon(props: IconProps) {
  const clipPathId = useId();
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g
        clipPath={`url(#${clipPathId})`}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z" />
        <path d="M10 5v5l3.333 1.667" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
